import React, { useState } from 'react';

import { useAuth } from '../context/AuthContext';
import { useGmailInviteAvailable } from '../hooks/useGmailInvite';

import { InvitePeopleModal } from './InvitePeopleModal';

/** The person-plus button beside "Download": opens Invite people, for users who can invite from Gmail. */
export function InvitePeopleControl({ className = '', projectId }: { className?: string; projectId?: string }) {
  const { user } = useAuth();
  const available = useGmailInviteAvailable(Boolean(user));
  const [isOpen, setIsOpen] = useState(false);

  if (!available) return null;

  return (
    <>
      <button
        aria-expanded={isOpen}
        aria-haspopup="dialog"
        aria-label="Invite people"
        className={`download-apps-control invite-people-control${className ? ` ${className}` : ''}`}
        onClick={() => setIsOpen(true)}
        title="Invite people"
        type="button"
      >
        <i aria-hidden="true" className="fa-solid fa-user-plus" />
      </button>
      <InvitePeopleModal isOpen={isOpen} onClose={() => setIsOpen(false)} projectId={projectId} />
    </>
  );
}
